// import React, { useState } from "react";
// import { jsPDF } from "jspdf";
// import "jspdf-autotable";
// import "../css/CollectionReport.css";

// const staticCollections = [
//   {
//     id: 422,
//     loanId: 7,
//     emiNumber: 2,
//     emiAmount: 230,
//     principalComponent: 200,
//     interestComponent: 30,
//     dueDate: "2025-08-27T00:00:00.000Z",
//     status: "paid",
//     paymentDate: "2025-09-23T16:42:53.000Z",
//     outstanding: 9600,
//     customerName: "Rahul Sharma",
//     loanNumber: "MZBR00100007",
//   },
//   {
//     id: 423,
//     loanId: 8,
//     emiNumber: 1,
//     emiAmount: 500,
//     principalComponent: 400,
//     interestComponent: 100,
//     dueDate: "2025-09-05T00:00:00.000Z",
//     status: "paid",
//     paymentDate: "2025-09-23T17:00:00.000Z",
//     outstanding: 4500,
//     customerName: "Priya Verma",
//     loanNumber: "MZBR00100008",
//   },
//   {
//     id: 424,
//     loanId: 9,
//     emiNumber: 3,
//     emiAmount: 300,
//     principalComponent: 250,
//     interestComponent: 50,
//     dueDate: "2025-09-10T00:00:00.000Z",
//     status: "pending",
//     paymentDate: null,
//     outstanding: 2700,
//     customerName: "Amit Singh",
//     loanNumber: "MZBR00100009",
//   },
// ];

// const CollectionReport = () => {
//   const [currentPage, setCurrentPage] = useState(1);
//   const [rowsPerPage, setRowsPerPage] = useState(10);

//   const totalPages = Math.ceil(staticCollections.length / rowsPerPage);
//   const startIndex = (currentPage - 1) * rowsPerPage;
//   const currentData = staticCollections.slice(startIndex, startIndex + rowsPerPage);

//   const handlePrev = () => currentPage > 1 && setCurrentPage(currentPage - 1);
//   const handleNext = () => currentPage < totalPages && setCurrentPage(currentPage + 1);

//   // PDF Export
//   const handleDownloadPDF = () => {
//     const doc = new jsPDF();
//     doc.setFontSize(18);
//     doc.text("Company Collection Report", 14, 20);

//     const tableColumn = [
//       "#",
//       "Customer Name",
//       "Loan Number",
//       "EMI Number",
//       "EMI Amount",
//       "Principal",
//       "Interest",
//       "Outstanding",
//       "Due Date",
//       "Payment Date",
//       "Status",
//     ];

//     const tableRows = currentData.map((c, index) => [
//       startIndex + index + 1,
//       c.customerName,
//       c.loanNumber,
//       c.emiNumber,
//       c.emiAmount,
//       c.principalComponent,
//       c.interestComponent,
//       c.outstanding,
//       new Date(c.dueDate).toLocaleDateString("en-IN"),
//       c.paymentDate ? new Date(c.paymentDate).toLocaleDateString("en-IN") : "-",
//       c.status,
//     ]);

//     doc.autoTable({
//       startY: 30,
//       head: [tableColumn],
//       body: tableRows,
//       theme: "grid",
//       headStyles: { fillColor: [99, 102, 241], textColor: 255 },
//       styles: { fontSize: 10, cellPadding: 3 },
//     });

//     doc.save("Collection_Report.pdf");
//   };

//   return (
//     <div className="CollectionReport-wrapper">
//       <h1 className="CollectionReport-title">📋 Collection Report</h1>

//       {/* Controls */}
//       <div className="CollectionReport-controls">
//         <label>
//           Show{" "}
//           <select
//             value={rowsPerPage}
//             onChange={(e) => {
//               setRowsPerPage(Number(e.target.value));
//               setCurrentPage(1);
//             }}
//           >
//             <option value={10}>10</option>
//             <option value={25}>25</option>
//             <option value={50}>50</option>
//           </select>{" "}
//           entries
//         </label>

//         <button className="filter-btn" onClick={handleDownloadPDF}>
//           📄 Download PDF
//         </button>
//       </div>

//       {/* Table */}
//       <div className="CollectionReport-table-container">
//         <table className="CollectionReport-table">
//           <thead>
//             <tr>
//               <th>#</th>
//               <th>Customer Name</th>
//               <th>Loan Number</th>
//               <th>EMI Number</th>
//               <th>EMI Amount</th>
//               <th>Principal</th>
//               <th>Interest</th>
//               <th>Outstanding</th>
          
//               <th>Payment Date</th>
//               <th>Status</th>
//             </tr>
//           </thead>
//           <tbody>
//             {currentData.length === 0 ? (
//               <tr>
//                 <td colSpan="11" className="CollectionReport-empty">
//                   ✅ No records found
//                 </td>
//               </tr>
//             ) : (
//               currentData.map((c, idx) => (
//                 <tr key={c.id}>
//                   <td>{startIndex + idx + 1}</td>
//                   <td>{c.customerName}</td>
//                   <td>{c.loanNumber}</td>
//                   <td>{c.emiNumber}</td>
//                   <td>₹{c.emiAmount.toLocaleString()}</td>
//                   <td>₹{c.principalComponent.toLocaleString()}</td>
//                   <td>₹{c.interestComponent.toLocaleString()}</td>
//                   <td>₹{c.outstanding.toLocaleString()}</td>
                
//                   <td>{c.paymentDate ? new Date(c.paymentDate).toLocaleDateString("en-IN") : "-"}</td>
//                   <td>
//                     <span className={`CollectionReport-status ${c.status === "pending" ? "pending" : "paid"}`}>
//                       {c.status}
//                     </span>
//                   </td>
//                 </tr>
//               ))
//             )}
//           </tbody>
//         </table>
//       </div>

//       {/* Pagination */}
//       <div className="CollectionReport-pagination">
//         <button className="pagination-btn" onClick={handlePrev} disabled={currentPage === 1}>
//           ⬅ Prev
//         </button>
//         <span className="pagination-info">
//           Page {currentPage} of {totalPages}
//         </span>
//         <button className="pagination-btn" onClick={handleNext} disabled={currentPage === totalPages}>
//           Next ➡
//         </button>
//       </div>
//     </div>
//   );
// };

// export default CollectionReport;
// import React, { useState, useEffect } from "react";
// import { jsPDF } from "jspdf";
// import autoTable from "jspdf-autotable";
// import axios from "axios";
// import "../css/CollectionReport.css";

// const API_URL = "https://payyug.in/api/loan-emi/";

// const CollectionReport = () => {
//   const [collections, setCollections] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [rowsPerPage, setRowsPerPage] = useState(10);

//   // 🔹 Fetch data from API
//   useEffect(() => {
//       const superAdminId = Number(localStorage.getItem("adminuserId")) || 0;

//     const fetchCollections = async () => {
//       try {
//         setLoading(true);
//         const res = await axios.get(`${API_URL}collection-sheet?superAdminId=${superAdminId}`);
//         if (res.data && res.data.collections) {
//           setCollections(res.data.collections);
//         }
//       } catch (error) {
//         console.error("Error fetching collection report:", error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchCollections();
//   }, []);

//   // 🔹 Pagination
//   const totalPages = Math.ceil(collections.length / rowsPerPage);
//   const startIndex = (currentPage - 1) * rowsPerPage;
//   const currentData = collections.slice(startIndex, startIndex + rowsPerPage);

//   const handlePrev = () => currentPage > 1 && setCurrentPage(currentPage - 1);
//   const handleNext = () => currentPage < totalPages && setCurrentPage(currentPage + 1);

//   // // 🔹 PDF Export
//   // const handleDownloadPDF = () => {
//   //   const doc = new jsPDF();
//   //   doc.setFontSize(18);
//   //   doc.text("Company Collection Report", 14, 20);

//   //   const tableColumn = [
//   //     "#",
//   //     "Customer Name",
//   //     "Loan Number",
//   //     "EMI Number",
//   //     "EMI Amount",
//   //     "Principal",
//   //     "Interest",
//   //     "Outstanding",
//   //     "Due Date",
//   //     "Payment Date",
//   //     "Status",
//   //   ];

//   //   const tableRows = currentData.map((c, index) => [
//   //     startIndex + index + 1,
//   //     c.customerName,
//   //     c.loanNumber,
//   //     c.emiNumber,
//   //     `₹${c.emiAmount.toLocaleString()}`,
//   //     `₹${c.principalComponent.toLocaleString()}`,
//   //     `₹${c.interestComponent.toLocaleString()}`,
//   //     `₹${c.outstanding.toLocaleString()}`,
//   //     new Date(c.dueDate).toLocaleDateString("en-IN"),
//   //     c.paymentDate ? new Date(c.paymentDate).toLocaleDateString("en-IN") : "-",
//   //     c.status,
//   //   ]);

//   //   autoTable(doc,{
//   //     startY: 30,
//   //     head: [tableColumn],
//   //     body: tableRows,
//   //     theme: "grid",
//   //     headStyles: { fillColor: [99, 102, 241], textColor: 255 },
//   //     styles: { fontSize: 10, cellPadding: 3 },
//   //   });

//   //   doc.save("Collection_Report.pdf");
//   // };





//   // 🔹 PDF Export (Professional Black & White Design)
// const handleDownloadPDF = () => {
//   const doc = new jsPDF();
//   doc.setFontSize(16);
//   doc.setFont("helvetica", "bold");
//   doc.text("📋 Company Collection Report", 14, 18);

//   const tableColumn = [
//     "#",
//     "Customer Name",
//     "Loan Number",
//     "EMI Number",
//     "EMI Amount",
//     "Principal",
//     "Interest",
//     "Outstanding",
//     "Due Date",
//     "Payment Date",
//     "Status",
//   ];

//   const tableRows = currentData.map((c, index) => [
//     startIndex + index + 1,
//     c.customerName,
//     c.loanNumber,
//     c.emiNumber,
//     `₹${c.emiAmount.toLocaleString()}`,
//     `₹${c.principalComponent.toLocaleString()}`,
//     `₹${c.interestComponent.toLocaleString()}`,
//     `₹${c.outstanding.toLocaleString()}`,
//     new Date(c.dueDate).toLocaleDateString("en-IN"),
//     c.paymentDate ? new Date(c.paymentDate).toLocaleDateString("en-IN") : "-",
//     c.status.toUpperCase(),
//   ]);

//   autoTable(doc, {
//     startY: 28,
//     head: [tableColumn],
//     body: tableRows,
//     theme: "grid",
//     headStyles: {
//       fillColor: [0, 0, 0], // Black header
//       textColor: [255, 255, 255], // White text
//       fontStyle: "bold",
//     },
//     styles: {
//       font: "helvetica",
//       fontSize: 9,
//       cellPadding: 3,
//       lineColor: [0, 0, 0], // Black borders
//       lineWidth: 0.1,
//       textColor: [0, 0, 0],
//     },
//     alternateRowStyles: {
//       fillColor: [240, 240, 240], // Light grey rows
//     },
//     bodyStyles: {
//       textColor: [0, 0, 0],
//     },
//   });

//   // Footer
//   const pageCount = doc.internal.getNumberOfPages();
//   for (let i = 1; i <= pageCount; i++) {
//     doc.setPage(i);
//     doc.setFontSize(8);
//     doc.setTextColor(100);
//     doc.text(
//       `Page ${i} of ${pageCount}`,
//       doc.internal.pageSize.getWidth() - 30,
//       doc.internal.pageSize.getHeight() - 10
//     );
//     doc.text("Generated by Collection System", 14, doc.internal.pageSize.getHeight() - 10);
//   }

//   doc.save("Collection_Report.pdf");
// };

//   return (
//     <div className="CollectionReport-wrapper">
//       <h1 className="CollectionReport-title">📋 Collection Report</h1>

//       {/* Controls */}
//       <div className="CollectionReport-controls">
//         <label>
//           Show{" "}
//           <select
//             value={rowsPerPage}
//             onChange={(e) => {
//               setRowsPerPage(Number(e.target.value));
//               setCurrentPage(1);
//             }}
//           >
//             <option value={10}>10</option>
//             <option value={25}>25</option>
//             <option value={50}>50</option>
//           </select>{" "}
//           entries
//         </label>

//         <button className="filter-btn" onClick={handleDownloadPDF}>
//           📄 Download PDF
//         </button>
//       </div>

//       {/* Table */}
//       <div className="CollectionReport-table-container">
//         {loading ? (
//           <p className="CollectionReport-loading">⏳ Loading data...</p>
//         ) : (
//           <table className="CollectionReport-table">
//             <thead>
//               <tr>
//                 <th>#</th>
//                 <th>Customer Name</th>
//                 <th>Loan Number</th>
//                 <th>EMI Number</th>
//                 <th>EMI Amount</th>
//                 <th>Principal</th>
//                 <th>Interest</th>
//                 <th>Outstanding</th>
//                 <th>Due Date</th>
//                 <th>Payment Date</th>
//                 <th>Status</th>
//               </tr>
//             </thead>
//             <tbody>
//               {currentData.length === 0 ? (
//                 <tr>
//                   <td colSpan="11" className="CollectionReport-empty">
//                     ✅ No records found
//                   </td>
//                 </tr>
//               ) : (
//                 currentData.map((c, idx) => (
//                   <tr key={c.id}>
//                     <td>{startIndex + idx + 1}</td>
//                     <td>{c.customerName}</td>
//                     <td>{c.loanNumber}</td>
//                     <td>{c.emiNumber}</td>
//                     <td>₹{c.emiAmount.toLocaleString()}</td>
//                     <td>₹{c.principalComponent.toLocaleString()}</td>
//                     <td>₹{c.interestComponent.toLocaleString()}</td>
//                     <td>₹{c.outstanding.toLocaleString()}</td>
//                     <td>{new Date(c.dueDate).toLocaleDateString("en-IN")}</td>
//                     <td>{c.paymentDate ? new Date(c.paymentDate).toLocaleDateString("en-IN") : "-"}</td>
//                     <td>
//                       <span className={`CollectionReport-status ${c.status === "pending" ? "pending" : "paid"}`}>
//                         {c.status}
//                       </span>
//                     </td>
//                   </tr>
//                 ))
//               )}
//             </tbody>
//           </table>
//         )}
//       </div>

//       {/* Pagination */}
//       {!loading && (
//         <div className="CollectionReport-pagination">
//           <button className="pagination-btn" onClick={handlePrev} disabled={currentPage === 1}>
//             ⬅ Prev
//           </button>
//           <span className="pagination-info">
//             Page {currentPage} of {totalPages}
//           </span>
//           <button className="pagination-btn" onClick={handleNext} disabled={currentPage === totalPages}>
//             Next ➡
//           </button>
//         </div>
//       )}
//     </div>
//   );
// };

// export default CollectionReport;


import React, { useState, useEffect } from "react";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import axios from "axios";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import "../css/CollectionReport.css";
import { useNavigate } from "react-router-dom";

const API_URL = "https://payyug.in/api/loan-emi/";

const CollectionReport = () => {
  const [collections, setCollections] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [company, setCompany] = useState(null);
  const [loanType, setLoanType] = useState("");
  const navigate = useNavigate();
    const superAdminId = Number(localStorage.getItem("adminuserId")) || 0;


  // 🔹 Fetch data from API
  useEffect(() => {
    const fetchCollections = async () => {
      try {
        setLoading(true);
        const res = await axios.get(`${API_URL}collection-sheet?superAdminId=${superAdminId}`);
        if (res.data && res.data.collections) {
          setCollections(res.data.collections);
        }
      } catch (error) {
        console.error("Error fetching collection report:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCollections();
  }, []);

    useEffect(() => {
        const fetchCompany = async () => {
          try {
            setLoading(true);
            const response = await fetch(
              `https://payyug.in/api/get-company?superAdminId=${superAdminId}`
            );
            const data = await response.json();
    
            if (response.ok && data) {
              // Dynamically construct logo URL
              if (data.logo) {
                data.logoUrl = `https://payyug.in/${data.logo.replace(/^images\//, '')}`;
              }
              setCompany(data);
            } else {
              console.error('Failed to fetch company data');
            }
          } catch (err) {
            console.error('Error fetching company details:', err);
          } finally {
            setLoading(false);
          }
        };
    
        if (superAdminId) fetchCompany();
      }, [navigate, superAdminId]);

  // 🔹 Pagination
  const filteredCollections = loanType
  ? collections.filter((c) => c.loanType?.toLowerCase() === loanType.toLowerCase())
  : collections;

  const totalPages = Math.ceil(filteredCollections.length / rowsPerPage);
  const startIndex = (currentPage - 1) * rowsPerPage;
  const currentData = filteredCollections.slice(startIndex, startIndex + rowsPerPage);
  const allData = filteredCollections.length;

  const handlePrev = () => currentPage > 1 && setCurrentPage(currentPage - 1);
  const handleNext = () => currentPage < totalPages && setCurrentPage(currentPage + 1);

  // 🔹 PDF Export
  // const handleDownloadPDF = () => {
  //   const doc = new jsPDF();
  //   doc.setFontSize(16);
  //   doc.setFont("helvetica", "bold");
  //   doc.text("📋 Company Collection Report", 14, 18);

  //   const tableColumn = [
  //     "#",
  //     "Customer Name",
  //     "Loan Number",
  //     "EMI Number",
  //     "EMI Amount",
  //     "Principal",
  //     "Interest",
  //     "Outstanding",
  //     "Due Date",
  //     "Payment Date",
  //     "Status",
  //   ];

  //   const tableRows = currentData.map((c, index) => [
  //     startIndex + index + 1,
  //     c.customerName,
  //     c.loanNumber,
  //     c.emiNumber,
  //     `₹${c.emiAmount.toLocaleString()}`,
  //     `₹${c.principalComponent.toLocaleString()}`,
  //     `₹${c.interestComponent.toLocaleString()}`,
  //     `₹${c.outstanding.toLocaleString()}`,
  //     new Date(c.dueDate).toLocaleDateString("en-IN"),
  //     c.paymentDate ? new Date(c.paymentDate).toLocaleDateString("en-IN") : "-",
  //     c.status.toUpperCase(),
  //   ]);

  //   autoTable(doc, {
  //     startY: 28,
  //     head: [tableColumn],
  //     body: tableRows,
  //     theme: "grid",
  //     headStyles: {
  //       fillColor: [0, 0, 0],
  //       textColor: [255, 255, 255],
  //       fontStyle: "bold",
  //     },
  //     styles: {
  //       font: "helvetica",
  //       fontSize: 9,
  //       cellPadding: 3,
  //       lineColor: [0, 0, 0],
  //       lineWidth: 0.1,
  //       textColor: [0, 0, 0],
  //     },
  //     alternateRowStyles: {
  //       fillColor: [240, 240, 240],
  //     },
  //     bodyStyles: {
  //       textColor: [0, 0, 0],
  //     },
  //   });

  //   const pageCount = doc.internal.getNumberOfPages();
  //   for (let i = 1; i <= pageCount; i++) {
  //     doc.setPage(i);
  //     doc.setFontSize(8);
  //     doc.setTextColor(100);
  //     doc.text(
  //       `Page ${i} of ${pageCount}`,
  //       doc.internal.pageSize.getWidth() - 30,
  //       doc.internal.pageSize.getHeight() - 10
  //     );
  //     doc.text("Generated by Collection System", 14, doc.internal.pageSize.getHeight() - 10);
  //   }

  //   doc.save("Collection_Report.pdf");
  // };


const handleDownloadPDF = async () => {
    const doc = new jsPDF("p", "mm", "a4");
    const pageWidth = doc.internal.pageSize.width;
    const pageHeight = doc.internal.pageSize.height;

    // ================= LOGO =================
    const logoX = 15;
    const logoY = 12;
    const logoSize = 25;
    const logoPadding = 2;

    // Border color & thickness
    doc.setDrawColor(0);
    doc.setLineWidth(0.2);

    // Calculate center of logo
    const centerX = logoX + logoSize / 2;
    const centerY = logoY + logoSize / 2;

    // Radius = half of logo + padding
    const radius = logoSize / 2 + logoPadding;

    // Draw circle
    doc.circle(centerX, centerY, radius);

    // Logo image
    if (company?.logoUrl) {
      try {
        const logoResp = await fetch(company.logoUrl);
        const logoBlob = await logoResp.blob();
        const reader = new FileReader();
        await new Promise((resolve) => {
          reader.onload = () => {
            doc.addImage(
              reader.result,
              "PNG",
              logoX,
              logoY,
              logoSize,
              logoSize,
            );
            resolve();
          };
          reader.readAsDataURL(logoBlob);
        });
      } catch {
        // silent fail
      }
    }

    // ================= COMPANY NAME (AUTO WRAP) =================
    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);

    const nameX = logoX + logoSize + 5;
    const nameY = 18;
    const nameMaxWidth = pageWidth - nameX - 15;

    const companyNameText = doc.splitTextToSize(
      (company?.name || "COMPANY NAME").toUpperCase(),
      nameMaxWidth,
    );

    doc.text(companyNameText, nameX, nameY);

    // Calculate Y after company name
    let currentY = nameY + companyNameText.length * 6;

    // ================= COMPANY DETAILS =================
    doc.setFont("helvetica", "normal");
    doc.setFontSize(11);

    const detailX = nameX;
    const detailMaxWidth = nameMaxWidth;

    // Address
    const addressText = doc.splitTextToSize(
      company?.address || "Company Address",
      detailMaxWidth,
    );
    doc.text(addressText, detailX, currentY);
    currentY += addressText.length * 5;

    // Email
    const emailText = doc.splitTextToSize(
      `Email: ${company?.email || "-"}`,
      detailMaxWidth,
    );
    doc.text(emailText, detailX, currentY);
    currentY += emailText.length * 5;

    // Phone
    const phoneText = doc.splitTextToSize(
      `Phone: ${company?.contact || "-"}`,
      detailMaxWidth,
    );
    doc.text(phoneText, detailX, currentY);
    currentY += phoneText.length * 5;

    // Divider
    doc.line(10, currentY + 4, pageWidth - 10, currentY + 4);

    // ================= REPORT TITLE =================
    doc.setFont("helvetica", "bold");
    doc.setFontSize(13);
    doc.text("Collection Report", pageWidth / 2, currentY + 14, {
      align: "center",
    });

    // ================= TABLE =================
    const tableColumn = [
    "#",
    "Customer Name",
    "Loan Number",
    "EMI Number",
    "EMI Amount",
    "Principal",
    "Interest",
    "Outstanding",
    "Due Date",
    "Payment Date",
    "Status",
    ];

    const tableRows = currentData.map((c, index) => [
      startIndex + index + 1,
      c.customerName,
      c.loanNumber,
      c.emiNumber,
      `Rs. ${c.emiAmount.toLocaleString("en-GB")}`,
      `Rs. ${c.principalComponent.toLocaleString("en-GB")}`,
      `Rs. ${c.interestComponent.toLocaleString("en-GB")}`,
      `Rs. ${c.outstanding.toLocaleString("en-GB")}`,
      new Date(c.dueDate).toLocaleDateString("en-GB"),
      c.paymentDate ? new Date(c.paymentDate).toLocaleDateString("en-GB") : "-",
      c.status.toUpperCase(),
    ]);

    autoTable(doc, {
      startY: currentY + 20,
      head: [tableColumn],
      body: tableRows,

      theme: "grid",
      styles: {
        fontSize: 7,
        cellPadding: 3,
        halign: "center",
      },
      headStyles: {
        fontStyle: "bold",
        fontSize: 7,
      },
      alternateRowStyles: {
        fillColor: [245, 245, 245],
      },

      didDrawPage: function () {
        const pageWidth = doc.internal.pageSize.width;
        const pageHeight = doc.internal.pageSize.height;

        doc.setDrawColor(0);
        doc.setLineWidth(0.2);

        // Page border on EVERY page
        doc.rect(8, 8, pageWidth - 16, pageHeight - 16);
      },
    });

    // ================= FOOTER =================
    const pageCount = doc.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      doc.setFontSize(8);
      doc.setTextColor(100);
      doc.text(`Page ${i} of ${pageCount}`, pageWidth - 30, pageHeight - 10);
      doc.text("Generated by Collection System", 14, pageHeight - 10);
    }

    doc.save("Collection_Report.pdf");
  };

  // 🔹 Excel Export
  const handleDownloadExcel = () => {
    const excelData = currentData.map((c, index) => ({
      "#": startIndex + index + 1,
      "Customer Name": c.customerName,
      "Loan Number": c.loanNumber,
      "EMI Number": c.emiNumber,
      "EMI Amount": c.emiAmount,
      "Principal": c.principalComponent,
      "Interest": c.interestComponent,
      "Outstanding": c.outstanding,
      "Due Date": new Date(c.dueDate).toLocaleDateString("en-IN"),
      "Payment Date": c.paymentDate
        ? new Date(c.paymentDate).toLocaleDateString("en-IN")
        : "-",
      "Status": c.status,
    }));

    const worksheet = XLSX.utils.json_to_sheet(excelData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Collection Report");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    });

    saveAs(blob, "Collection_Report.xlsx");
  };

   const handleChange = (e) => {
   
  };

  return (
    <div className="CollectionReport-wrapper">
      <h1 className="CollectionReport-title">📋 Collection Report</h1>

      <div className="CollectionReport-grid">
          <div className="CollectionReport-formGroup">
            <label>From Date</label>
            <input type="date" name="fromDate" onChange={handleChange} />
          </div>
          <div className="CollectionReport-formGroup">
            <label>To Date</label>
            <input type="date" name="toDate" onChange={handleChange} />
          </div>
          <select
            className="collectionreport-loantype-select"
            value={loanType}
            onChange={(e) => {
              setLoanType(e.target.value);
              setCurrentPage(1);
            }}
          >
            <option value="">All Loan Types</option>
            <option value="Fixed">Fixed</option>
            <option value="Personal">Personal</option>
          </select>
      </div>

      {/* Controls */}
      <div className="CollectionReport-controls">
        <label>
          Show{" "}
          <select
            value={rowsPerPage}
            onChange={(e) => {
              setRowsPerPage(Number(e.target.value));
              setCurrentPage(1);
            }}
          >
            <option value={10}>10</option>
            <option value={25}>25</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
            <option value={allData}>All</option>
          </select>{" "}
          entries
        </label>

        <div className="CollectionReport-actions">
          <button className="filter-btn excel-btn" onClick={handleDownloadExcel}>
            📊 Download Excel
          </button>
          <button className="filter-btn" onClick={handleDownloadPDF}>
            📄 Download PDF
          </button>
        </div>
      </div>

      {/* Table */}
      <div className="CollectionReport-table-container">
        {loading ? (
          <p className="CollectionReport-loading">⏳ Loading data...</p>
        ) : (
          <table className="CollectionReport-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Customer Name</th>
                <th>Loan Number</th>
                <th>EMI Number</th>
                <th>EMI Amount</th>
                <th>Principal</th>
                <th>Interest</th>
                <th>Outstanding</th>
                <th>Due Date</th>
                <th>Payment Date</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {currentData.length === 0 ? (
                <tr>
                  <td colSpan="11" className="CollectionReport-empty">
                    ✅ No records found
                  </td>
                </tr>
              ) : (
                currentData.map((c, idx) => (
                  <tr key={c.id}>
                    <td>{startIndex + idx + 1}</td>
                    <td>{c.customerName||"N/A"}</td>
                    <td>{c.loanNumber||"N/A"}</td>
                    <td>{c.emiNumber||"N/A"}</td>
                    <td>{`₹${c.emiAmount.toLocaleString()}`||"N/A"}</td>
                    <td>{`₹${c.principalComponent.toLocaleString()}`||"N/A"}</td>
                    <td>{`₹${c.interestComponent.toLocaleString()}`||"N/A"}</td>
                    <td>{`₹${c.outstanding.toLocaleString()}`||"N/A"}</td>
                    <td>{new Date(c.dueDate).toLocaleDateString("en-GB")||"N/A"}</td>
                    <td>{c.paymentDate ? new Date(c.paymentDate).toLocaleDateString("en-GB") : "N/A"}</td>
                    <td>
                      <span className={`CollectionReport-status ${c.status === "pending" ? "pending" : "paid"}`}>
                        {c.status}
                      </span>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        )}
      </div>

      {/* Pagination */}
      {!loading && (
        <div className="CollectionReport-pagination">
          <button className="pagination-btn" onClick={handlePrev} disabled={currentPage === 1}>
            ⬅ Prev
          </button>
          <span className="pagination-info">
            Page {currentPage} of {totalPages}
          </span>
          <button className="pagination-btn" onClick={handleNext} disabled={currentPage === totalPages}>
            Next ➡
          </button>
        </div>
      )}
    </div>
  );
};

export default CollectionReport;
